
import { ArrivalCheckView } from "../views/arrivalCheckView.jsx";
import { useParams } from "react-router-dom";
import locationTask from "../data/locationTask.json";


function ArrivalCheck() {
  const { id } = useParams();
  const location = locationTask[id];
    const imageKey = `drawing_${id}`;

  function handleArrivalCheckACB(hasArrived) {
    if (hasArrived) {
      window.location.hash = `#/modeSelection/${id}`;
    } else {
      window.location.hash = `#/notArrived/${id}`;
    }
  }

  if (!location) {
    return <div>Oops! Location not found.</div>;
  }

  return (
    <ArrivalCheckView
      locId={id}
      location={location}
      onProceed={handleArrivalCheckACB}
      imageKey={imageKey}
    />
  );
}

export { ArrivalCheck };



